import "./iconButton.scss";
import Loading from "../../assets/images/loadingGreen16.svg";
export default function IconButton({ icon, onClick, loading, tooltip, className = "" }) {
  return (
    <div className={`iconButton ${className}`} onClick={onClick}>
        {tooltip && <div className="tip">{tooltip}</div>}
        <img src={loading ? Loading : icon} alt="enterIcon" />
    </div>
  );
}
